import React, { useState, useEffect } from 'react';
import api from '../../api/auth';

const TeacherMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [classes, setClasses] = useState([]);
  const [students, setStudents] = useState([]);
  const [parents, setParents] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedStudent, setSelectedStudent] = useState('');
  const [selectedParent, setSelectedParent] = useState('');
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');

  useEffect(() => {
    fetchMessages();
    fetchClasses();
  }, []);

  const fetchMessages = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await api.get('/teacher/messages', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMessages(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('Erreur:', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchClasses = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await api.get('/teacher/classes', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setClasses(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('Erreur:', err);
    }
  };

  const loadStudents = async (classId) => {
    try {
      const token = localStorage.getItem('token');
      const res = await api.get(`/teacher/classes/${classId}/students`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStudents(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('Erreur:', err);
      setStudents([]);
    }
  };

  const loadParents = async (studentId) => {
    try {
      const token = localStorage.getItem('token');
      const res = await api.get(`/teacher/students/${studentId}/parents`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setParents(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('Erreur:', err);
      setParents([]);
    }
  };

  const handleClassChange = (e) => {
    const id = e.target.value;
    setSelectedClass(id);
    setSelectedStudent('');
    setSelectedParent('');
    setStudents([]);
    setParents([]);
    if (id) loadStudents(id);
  };

  const handleStudentChange = (e) => {
    const id = e.target.value;
    setSelectedStudent(id);
    setSelectedParent('');
    setParents([]);
    if (id) loadParents(id);
  };

  const handleSend = async (e) => {
    e.preventDefault();
    if (!selectedStudent || !selectedParent || !body) {
      alert('Veuillez remplir tous les champs');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      await api.post('/teacher/messages', {
        to_user_id: selectedParent,
        student_id: selectedStudent,
        subject: subject,
        body: body,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setSubject('');
      setBody('');
      setShowForm(false);
      setSelectedClass('');
      setSelectedStudent('');
      setSelectedParent('');
      alert('✅ Message envoyé !');
      fetchMessages();
    } catch (err) {
      console.error('Erreur:', err);
      alert('❌ Erreur : ' + (err.response?.data?.error || err.message));
    }
  };

  if (loading) return <div className="p-6">Chargement...</div>;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-[#2C3E50]">💬 Messagerie</h1>
          <p className="text-gray-500">Échangez avec les parents de vos élèves</p>
        </div>
        <button
          onClick={() => setShowForm(!showForm)}
          className="bg-[#E67E22] text-white px-4 py-2 rounded-lg hover:bg-[#D35400]"
        >
          {showForm ? 'Annuler' : '+ Nouveau message'}
        </button>
      </div>

      {showForm && (
        <div className="bg-white rounded-xl shadow-md p-6">
          <h3 className="font-bold mb-4">Nouveau message à un parent</h3>
          <form onSubmit={handleSend} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">Classe</label>
              <select
                value={selectedClass}
                onChange={handleClassChange}
                className="w-full px-4 py-2 border rounded-lg"
                required
              >
                <option value="">-- Choisir une classe --</option>
                {classes.map((c) => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Élève</label>
              <select
                value={selectedStudent}
                onChange={handleStudentChange}
                className="w-full px-4 py-2 border rounded-lg"
                required
                disabled={!selectedClass}
              >
                <option value="">-- Choisir un élève --</option>
                {students.map((s) => (
                  <option key={s.id} value={s.id}>{s.name}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Parent</label>
              <select
                value={selectedParent}
                onChange={(e) => setSelectedParent(e.target.value)}
                className="w-full px-4 py-2 border rounded-lg"
                required
                disabled={!selectedStudent}
              >
                <option value="">-- Choisir un parent --</option>
                {parents.map((p) => (
                  <option key={p.id} value={p.id}>{p.name}</option>
                ))}
              </select>
              {selectedStudent && parents.length === 0 && (
                <p className="text-sm text-gray-500 mt-1">Aucun parent lié à cet élève</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Sujet</label>
              <input
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="w-full px-4 py-2 border rounded-lg"
                placeholder="Ex: Comportement en classe"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Message</label>
              <textarea
                value={body}
                onChange={(e) => setBody(e.target.value)}
                className="w-full px-4 py-2 border rounded-lg"
                rows="5"
                required
              />
            </div>

            <button
              type="submit"
              className="bg-[#E67E22] text-white px-6 py-2 rounded-lg hover:bg-[#D35400]"
            >
              Envoyer
            </button>
          </form>
        </div>
      )}

      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        {messages.length === 0 ? (
          <div className="p-8 text-center text-gray-500">Aucun message</div>
        ) : (
          <div className="divide-y">
            {messages.map((msg) => (
              <div key={msg.id} className="p-4 hover:bg-gray-50">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-semibold text-[#2C3E50]">
                      {msg.from_me ? `À : ${msg.to_name}` : `De : ${msg.from_name}`}
                    </p>
                    {msg.subject && <p className="text-sm text-gray-600">📌 {msg.subject}</p>}
                    <p className="text-sm text-gray-500 mt-1">👧 {msg.student_name}</p>
                    <p className="text-sm mt-2">{msg.body}</p>
                  </div>
                  <span className="text-xs text-gray-400">{msg.created_at}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TeacherMessages;